import React from 'react';

import { IInvitedFragment } from '../interface';

import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import { Button } from 'components/Button';

import iconSuccess from 'img/success-img.svg';

import authServices from 'core/authentication/authService';

import './styles.scss';

const RegistrationSuccess: React.FC<IInvitedFragment> = () => {
  const _authService = new authServices();

  async function completeRegistration() {
    await _authService.logout();
  }

  return (
    <div className="animated fadeIn">
      <Column className="mt-2 align-center">
        <img src={iconSuccess} alt="" className="icon-success-ajust" />
        <Text size={16} className="color-primary font-bold text-center mt-1">
          Cadastro atualizado com sucesso
        </Text>
        <Text
          size={12}
          className="text-center color-blue-gray mt-3 text-wrap px-10 px-sm-0"
          textOveflow="none"
        >
          Obrigado pelas informações. Clique no botão abaixo para continuar seu
          acesso.
        </Text>
        <Row className="justify-center mt-5">
          <Button
            onClick={completeRegistration}
            className="bg-primary outline"
            width="auto"
          >
            <Text className="color-primary px-5">Continuar</Text>
          </Button>
        </Row>
      </Column>
    </div>
  );
};

export default RegistrationSuccess;
